import { WORKSPACE_AGENT_CONSENT_DOCK_DEFAULT_APPROVE_LABEL } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentComposerChrome';
import {
  type AgentElicitationDisplaySampleItem,
  type ToolConsentElicitation,
} from '~/components/v2/components/workspace/workspace-agent-panel/schemas/elicitation';
export const FALLBACK_TOOL_CONSENT_INSTRUCTION = 'The agent needs your approval to continue.';

/** Prototype `TrinityZeroApprovalDock` remember row copy. */
export const TOOL_CONSENT_ALLOW_FOR_THIS_THREAD_LABEL = 'Always allow in this thread';

/** Approvals decline with Deny; question docks keep Cancel. */
export const TOOL_CONSENT_DENY_LABEL = 'Deny';

/** Prototype permission-gate primary action. */
export const TOOL_CONSENT_DEFAULT_APPROVE_LABEL = WORKSPACE_AGENT_CONSENT_DOCK_DEFAULT_APPROVE_LABEL;

/** Prototype `approveLabelForFlow` labels for write gates. */
export const TOOL_CONSENT_APPROVE_LABEL_RENAME = 'Accept changes';
export const TOOL_CONSENT_APPROVE_LABEL_APPLY = 'Apply changes';

export type ToolConsentDockCopy = {
  approveLabel: string;
  instruction: string;
  sample: AgentElicitationDisplaySampleItem[] | undefined;
  summary: string | undefined;
  title: string;
  truncated: boolean;
};

/** Prototype `approveLabelForFlow` — write gates name the action; everything else stays generic. */
export const getToolConsentDockApproveLabel = (toolName: string): string => {
  switch (toolName) {
    case 'apply_rename':
      return TOOL_CONSENT_APPROVE_LABEL_RENAME;
    case 'apply_tags':
    case 'assign_custom_field_values':
      return TOOL_CONSENT_APPROVE_LABEL_APPLY;
    default:
      return TOOL_CONSENT_DEFAULT_APPROVE_LABEL;
  }
};

/**
 * Agent-owned display wins so one dock can confirm any gated tool. Payloads from before WORK-337
 * omit `display`; those still need a title and instruction or the dock is blank.
 */
export const getToolConsentDockCopy = (elicitation: ToolConsentElicitation): ToolConsentDockCopy => {
  const display = elicitation.payload.display;
  const title = (display?.title ?? '').trim();
  const instruction = (display?.instruction ?? '').trim();
  const approveLabel = getToolConsentDockApproveLabel(elicitation.payload.toolName);

  if (display && title && instruction) {
    return {
      approveLabel,
      instruction,
      sample: display.sample,
      summary: display.summary,
      title,
      truncated: display.truncated === true,
    };
  }

  return {
    approveLabel,
    instruction: FALLBACK_TOOL_CONSENT_INSTRUCTION,
    sample: undefined,
    summary: undefined,
    title: `Approval required: ${elicitation.payload.toolName}`,
    truncated: false,
  };
};
